export default {
  customSelect: {
    border: 'none',
    padding: '0px 0px 12px',
    marginRight: '16px',
    gap: '10px',

    borderBottom: '2px solid #42ABC8',

    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '24px',

    width: '100%',

    '@media (max-width: 768px)': {
      marginBottom: '12px',
    },
  },
};
